import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Quiero que interpretes una **Tirada de Encrucijada del Alma** con 10 cartas, ayudando al consultante ${
        data.consultante
    } a clarificar un dilema o decisión importante desde la perspectiva del alma, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta o dilema que plantea el consultante: ' +
              data.consulta +
              ','
            : ''
    } según estas cartas: **Energía actual de la situación — Contexto actual (¿cómo está realmente la situación que te genera esta duda?):** ${cardLabel(
        cards[0]
    )}, **La raíz del dilema — Raíz del conflicto (¿qué es lo que realmente está en juego detrás de esta decisión?):** ${cardLabel(
        cards[1]
    )}, **Camino A — Energía y lo que aporta — Opción 1 (si tomás este camino, ¿qué energía trae y qué te aporta a nivel del alma?):** ${cardLabel(
        cards[2]
    )}, **Camino B — Energía y lo que aporta — Opción 2 (si tomás este otro camino, ¿qué energía trae y qué te aporta?):** ${cardLabel(
        cards[3]
    )}, **Qué bloquea o complica el Camino A — Obstáculo Opción 1 (¿qué dificultad o resistencia tiene esta opción?):** ${cardLabel(
        cards[4]
    )}, **Qué bloquea o complica el Camino B — Obstáculo Opción 2 (¿qué dificultad o resistencia tiene esta otra opción?):** ${cardLabel(
        cards[5]
    )}, **Consejo del alma / universo — Guía principal (¿qué te recomienda tu parte más sabia para esta decisión?):** ${cardLabel(
        cards[6]
    )}, **Qué necesitás soltar para decidir con claridad — Liberación necesaria (¿qué creencia, miedo o apego te está dificultando ver con claridad?):** ${cardLabel(
        cards[7]
    )}, **Primer paso recomendado — Acción concreta (¿cuál es el paso más alineado que podés dar ahora?):** ${cardLabel(
        cards[8]
    )} y **Visión probable si seguís el consejo — Cierre y orientación (¿cómo se ve el panorama si seguís la recomendación de tu alma?):** ${cardLabel(
        cards[9]
    )}. Explica detalladamente cada carta y su significado en la posición donde ha salido. Teje una lectura coherente sobre la encrucijada: compara ambos caminos con honestidad, sin forzar una opción si las cartas no lo indican, y conecta el dilema con su raíz, los obstáculos de cada opción y la guía del alma. Detecta miedos, apegos y patrones que nublan la decisión. Proporciona orientación clara, práctica y alineada con el crecimiento del consultante. Mantén un tono profesional, empático, equilibrado y comprensible. Dirígete directamente al consultante, no utilices la tercera persona refiriéndote al consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 párrafos después de la lectura, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
